/**
 * © 2025 Malvys Exaucé Dessou — ZonePro. Tous droits réservés.
 */
import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="w-full py-4 text-center border-t border-border/40 bg-zonepro-surface/50 backdrop-blur-sm">
      <p className="text-xs text-muted-foreground">
        {t('footer.copyright')}
      </p>
    </footer>
  );
};

export default Footer;
